import { useTranslator } from '@bluebeam/react-i18n';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import './SubscriptionHero.css';

const SubscriptionHero = (): ReactElement => {
  const { translate } = useTranslator(['subscriptionHero']);

  const searchHandler = (): string => {
    const transferLinkQueries = [
      {
        url: process.env.US_DASHBOARD_URL,
        search: '?cclcl=en_US',
      },
      {
        url: process.env.UK_DASHBOARD_URL,
        search: '?cclcl=en_GB',
      },
      {
        url: process.env.AU_DASHBOARD_URL,
        search: '?cclcl=en_AU',
      },
      {
        url: process.env.SE_DASHBOARD_URL,
        search: '?cclcl=sv_SE',
      },
      {
        url: process.env.DE_DASHBOARD_URL,
        search: '?cclcl=de_DE',
      },
    ];

    const element = transferLinkQueries.find(
      (element) => element.url?.toString() === window.location.origin.toString()
    );

    const search = element ? element.search : '';

    return search;
  };

  return (
    <section className="index-hero subscription-hero w100 flex justify-center align-center">
      <div className="inner-wrapper su-align-self-center w100 flex justify-between align-center">
        <div className="subscription-buy-now-wrapper">
          <h1 className="size-36 semi-bold">
            {translate('subscriptionHero:bluebeamSubscription')}
          </h1>
          <h2 className="size-20 su-mt4">
            {translate('subscriptionHero:upgradeToday')}
          </h2>
          <p className="size-14 su-mt3 su-mb0">
            {translate('subscriptionHero:visitWebstore')}
          </p>
          <Link
            to={{
              pathname: process.env.BLUEBEAM_STORE_URL,
              search: searchHandler(),
            }}
            className="buy-now-button inline-block btn-lg btn-primary su-mt6"
            target="_blank"
          >
            {translate('subscriptionHero:buyNow')}
          </Link>
        </div>
        <div className="other-ways-wrapper su-ml7">
          <h3 className="size-24">
            {translate('subscriptionHero:otherUpgrades')}
          </h3>
          <p className="question">{translate('subscriptionHero:question1')}</p>
          <p className="answer">{translate('subscriptionHero:answer1')}</p>
          <p className="question">{translate('subscriptionHero:question2')}</p>
          <p className="answer">{translate('subscriptionHero:answer2')}</p>
          <p className="question">{translate('subscriptionHero:question3')}</p>
          <p className="answer">{translate('subscriptionHero:answer3')}</p>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionHero;
